const Search = () => import('./Search')

export default function installComponents(Vue) {
  Vue.component('Search', Search)
}
